import * as actions from 'actions/sellerDetailActions';
import { LOADING, INIT, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
import { get } from 'lodash';
const defaultState = {
    asyncStatus: INIT,
    data: []
};
export default function sellerDetails(state = defaultState, action) {
    switch (action.type) {
        case actions.GET_SELLER_DETAILS_REQUEST:
            return Object.assign({}, state, {
                asyncStatus: LOADING
            });
        case actions.GET_SELLER_DETAILS_SUCCESS:
            const slots = get(action, 'data.slots', []);
            const slotData = slots.filter((slot) => {
                const slotType = get(slot, 'widget.type', '');
                return slotType === 'SELLER_RATING_DETAILS';
            })[0];
            return Object.assign({}, state, {
                asyncStatus: SUCCESS,
                data: get(slotData, 'widget.data')
            });
        case actions.GET_SELLER_DETAILS_ERROR:
            return Object.assign({}, state, {
                asyncStatus: ERROR
            });
        case actions.RESET_SELLER_DETAILS:
            return Object.assign({}, state, {
                asyncStatus: INIT
            });
        default:
            return state;
    }
}
